/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/areas.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { AuditApplicationArea } from 'types/graphql-global-types';

const Areas = [
    { name: 'ADMIN', type: AuditApplicationArea.ADMIN },
    { name: 'CENTRAL MONITORING', type: AuditApplicationArea.CENTRAL_MONITORING },
    { name: 'RISK ASSESSMENT', type: AuditApplicationArea.RISK_ASSESSMENT },
    { name: 'PROTOCOL INSIGHTS', type: AuditApplicationArea.PROTOCOL_INSIGHTS },
    { name: 'OPRA', type: AuditApplicationArea.OPRA },
];

export default Areas;
